// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"MiddleComponent_headerContainer__3nSvj","leftContainer":"MiddleComponent_leftContainer__1ARtD","rightContainer":"MiddleComponent_rightContainer__2dO4r"};